import script from "./TicketCardOffice.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketCardOffice.vue?vue&type=script&setup=true&lang=js"

import "./TicketCardOffice.vue?vue&type=style&index=0&id=1e886950&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e886950"]])

export default __exports__